export enum BrandAuthorization {
    None = "None",
    Caterpillar = "Caterpillar",
    Mitsubishi = "Mitsubishi",
    Jungheinrich = "Jungheinrich",
    Nichiyu = "Nichiyu",
    TowMotor = "TowMotor",
}
